import { render, staticRenderFns } from "./receivingAcceptance.vue?vue&type=template&id=689bf3ff&scoped=true"
import script from "./receivingAcceptance.vue?vue&type=script&lang=js"
export * from "./receivingAcceptance.vue?vue&type=script&lang=js"
import style0 from "./receivingAcceptance.vue?vue&type=style&index=0&id=689bf3ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689bf3ff",
  null
  
)

export default component.exports